// extracted by mini-css-extract-plugin
module.exports = {"thumbs-gallery":"styles_thumbs-gallery__UMMGM"};